<template>
    <div v-if="additionals">
        <div v-if="additionals.salaVacinacaoLogada && !!additionals.salaVacinacaoLogada.id">
            <rkm-data-table
                :fields="fields"
                :repository="repositories.entrada"
                ref="DataTableEntrada"
            >
                <template v-slot:cell(actions)="row">
                    <rkm-button
                        @click="$refs.ModalEstorno.open(row.item)"
                        authorize="create-imunizacao-entrada"
                        color="danger"
                        small
                        title="Novo estorno"
                    >
                        <rkm-icon icon="undo-alt" />
                    </rkm-button>
                </template>
            </rkm-data-table>

            <ModalEstorno
                @save="$refs.DataTableEntrada.refresh()"
                ref="ModalEstorno"
            />
        </div>

        <rkm-alert v-else color="warning">
            A unidade logada não é uma sala de vacinação ou está desativada, favor cadastra-la para efetuar uma entrada.
        </rkm-alert>
    </div>
</template>

<script>
// Components.
import ModalEstorno from './components/estorno/Modal'

// Mixins.
import { error, permissao, repository } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalEstorno },
    computed: {
        fields() {
            const fields = [
                { key: 'unidadeNome', label: 'Unidade', name: 'cadastroUnidade.nomeFantasia', searchable: true, sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', name: 'cadastroInfraestrutura.nome', searchable: true, sortable: true },
                { key: 'dataEntrada', label: 'Data da entrada', name: 'imunizacaoEntrada.dataEntrada', searchable: true, sortable: true },
                { key: 'origem', label: 'Origem', name: 'imunizacaoEntrada.origem', searchable: true, sortable: true },
            ]

            if (this.verificarPermissao('create-imunizacao-entrada')) {
                fields.push({ class: 'col-min text-center', key: 'actions', label: 'Ações' })
            }

            return fields
        },
    },
    created() {
        this.repositories = {
            entrada: this.getConectaSusRepository('imunizacao.entrada')
        }
    },
    data: () => ({
        additionals: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.entrada.index()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.$emit('loaded', this.additionals)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, permissao, repository ],
    mounted() {
        this.load()
    },
}
</script>